import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Footer, Header } from 'src/features';

import { GreenEllipseBottom, GreenEllipseTop } from 'src/assets';
import './appLayout.scss';

export const AppLayout = (props) => {
  const { children } = props;

  const { pathname } = useLocation();

  const isHome = pathname === '/';

  return (
    <div className="app-layout">
      <div className="app-layout__content">
        <Header />
        <div className="app-layout__body">{children || <Outlet />}</div>
        <Footer />
      </div>

      <img src={GreenEllipseBottom} alt={GreenEllipseBottom} className="app-layout__image-1" />
      {isHome && (
        <img src={GreenEllipseTop} alt={GreenEllipseTop} className="app-layout__image-2" />
      )}
    </div>
  );
};
